import React, { useEffect, useRef, useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
// import DefaultImage from '../../../assets/images/userAvatar.png'
// import DefaultVideo from '../../../assets/video/demoVideo.mp4'

function Photo ({ items }) {
  function checkFileType (url) {
    const fileExtension = url.split('.').pop().toLowerCase()

    if (fileExtension === 'pdf') {
      return 'PDF'
    } else if (
      ['jpeg', 'jpg', 'png', 'gif', 'bmp'].includes(fileExtension)
    ) {
      return 'Image'
    } else {
      return 'Unknown'
    }
  }
  const [images, setImages] = useState([])
  const [open, setOpen] = useState(false)
  const [imageIndex, setImageIndex] = useState(0)

  const imageDialog = index => {
    if (items?.photos?.length > 0) {
      setOpen(true)
      setImageIndex(index)
      setImages(
        items?.photos?.map(res => {
          return {
            src: res,
            width: 3840,
            height: 2560
          }
        })
      )
    }
  }
  return (
    <>
      <div className=''>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <tbody>
            <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
              <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
                360 URL
              </th>
              <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.threeSixtyView ? <a href={items?.threeSixtyView} className='text-blue-500' target='_blank' rel='noreferrer' > 360 View</a>: 'N/A'}

              </th>
            </tr>
            {/* <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
              <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
                Video URL
              </th>
              <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.videos? items?.videos?.map((video,index)=><a href={video} target='_blank' className={`text-blue-500 ${index===1 &&'ml-2'}`} rel='noreferrer' >View</a>):'N/A'}

              </th>
            </tr> */}
          </tbody>
        </table>

        <div className='photos'>
          <div className='text-50px font-medium text-lg p-6 pb-0'>
            Photos
          </div>
          <div className='images-container pl-6 pr-4 flex flex-wrap'>
            {items?.photos && items?.photos?.length > 0
              ? items?.photos?.map((val, ind) =>
                <div className='item object-cover w-24 h-24 border overflow-hidden  m-2' key={ind}
                onClick={() => {
                  imageDialog(ind)
                }}
                >
                  <img src={val} alt='image' className='object-cover w-24 h-24' />
                </div>
              )
              : 'No photo found'}

          </div>
        </div>

        <div className='videos'>
          <div className='text-50px font-medium text-lg p-6 pb-0'>
            Videos
          </div>
          <div className='images-container pl-6 pr-4 flex flex-wrap'>
            {Array.isArray(items?.videos) && items?.videos?.length > 0 ? items?.videos?.map((val, ind) => <div key={ind} className='item w-[270px] h-full border   m-2 '> <video controls><source src={val} type='video/mp4' />Your browser does not support the video tag. </video> </div>) : 'No video found'}
              
          </div>
        </div>
        <div className='floor-plan'>
          <div className='text-50px font-medium text-lg p-6 pb-0'>
            Floor Plan
          </div>
          <div className='images-container pl-6 pr-4 flex flex-wrap'>
            {Array.isArray(items?.floor_plan) && items?.floor_plan?.length > 0
              ? items?.floor_plan?.map((val, ind) => <div className='item object-cover  m-2' key={ind}>
                {checkFileType(val?.image) === 'Image' ? <><img src={val?.image} alt='details' className='object-cover w-24 h-24' /><h3 className='m-2'>{val?.title}</h3><h3 className='m-2'>{val?.titleAr}</h3></> : checkFileType(val?.image) === 'PDF' ? <a href={val?.image} target='_blank' className='p-2 bg-gray-100 rounded-sm' rel='noreferrer'>{val?.title}</a> : 'No floor plan found'}
              </div>)
              : 'No floor plan found'}
            {/* <div className=''>
                <div className='item w-[270px] h-[160px] border   m-2 '>
                    <video controls>
                    <source src={DefaultVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                    </video>
                </div>
                <h3 className="m-2 text-lg font-medium">Floor Name 1</h3>
            </div> */}
          </div>
        </div>
      </div>
      {open && (
        <Lightbox
          open={open}
          plugins={[ Thumbnails]}
          close={() => setOpen(false)}
          slides={images}
          index={imageIndex}
        />
      )}
    </>
  )
}

export default Photo
